import $ from "jquery";

const removeExtraBillingAddressInput = () => {
  const init = () => {
    removeBillingAddress();
  };

  const removeBillingAddress = () => {
    const el = {
      billing: "#billing_address_2_field",
    };

    if ($(el.billing).length === 0) return;

    $(el.billing).remove();
  };

  init();
};

try {
  removeExtraBillingAddressInput();
} catch (error) {
  console.error(error);
}
